package szlot

import kotlinx.serialization.Serializable
import kotlinx.serialization.json.Json
import visage.core.*
import visage.rmi.*
import kotlin.coroutines.CoroutineContext
import kotlin.coroutines.suspendCoroutine
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.Job
import kotlinx.coroutines.launch

abstract class AGreeterControllerFe(props: szlot.GreeterProps, scene: MGreeterScene)
 : AController<szlot.GreeterProps, szlot.GreeterModel, GreeterSceneState>(props, scene) {

    val backend = GreeterControllerBeProxy(this)
    val coroutineScope = DefaultControllerScope()

    fun launchOnDefaultControllerScope(block: suspend CoroutineScope.() -> Unit) {
        this.coroutineScope.launch(block = block)
    }

    fun call_greet(name: kotlin.String) {
        launchOnDefaultControllerScope {
            render(backend.greet(name))
        }
    }

    class DefaultControllerScope : CoroutineScope {
        private val job = Job()

        override val coroutineContext: CoroutineContext
            get() = Dispatchers.Main + job
    }
}

class GreeterControllerBeProxy(private val controller: AGreeterControllerFe) {

    suspend fun greet(name: kotlin.String): szlot.GreeterModel {
        @Serializable
        class ParamsWrapper(val name: kotlin.String)
        val params: String = Json.encodeToString(ParamsWrapper.serializer(), ParamsWrapper(name))
        val p = RmiParams(
            action = "szlot.GreeterControllerBe.greet",
            methodParams = params,
            props = Json.encodeToString(szlot.GreeterProps.serializer(), controller.props),
            currentModel = Json.encodeToString(szlot.GreeterModel.serializer(), controller.model)
        )
        return suspendCoroutine { res ->
            val promise = RmiClient.call(p)
            RmiClient.handleResult(controller.model, res, promise, szlot.GreeterModel.serializer())
        }
    }

}
